export const MAIN_PAGE_NAVIGATION = "/main";
export default {};
